<template>
<v-container grid-list-xs text-xs-center :class="$style.widgetContainer">
    <v-layout row wrap>
        <v-flex xs12>
            <v-card elevation='20' style="background-color: white !important;">
                <div :class="$style.widgetContainerMain">
                    <div :class="$style.widgetContainerTitle">
                        <div :class="$style.widgetContainerTitleIconWrapper">
                            <div :class="$style.widgetContainerTitleIcon">
                                <v-icon color="#0090c1">
                                    fas fa-book-open
                                </v-icon>
                            </div>
                        </div>  
                        <p v-html="label[language].title">
                        </p>
                    </div>
                    <div>
                        <svg_icon :src="triangle" :class="$style.triangle"/>
                    </div>
                </div>
                <!-- <v-card-title class="px-0 title" 
                    style="background-color: #bebebe; justify-content: center; border: 1px solid #b3b3b3;">{{label[language].title}}</v-card-title>             -->
                <div style="width:97%; margin: 0 auto;">
                    <!-- <v-card-title class="px-0 pb-0">{{label[language].subtitle_1}}</v-card-title> -->
                    <v-card-text class="px-0" v-html="label[language].parag_1"></v-card-text>

                    <ol :class="$style.referenceList">
                        <li v-for="(listItem, index) in label[language].reference" :key='index' v-html="listItem"></li>
                    </ol>
                </div>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import labels from './LanguageLabels_6.js'
import svg_icon from '@/components/svg/svg_icon.vue';
import triangle from './assets/triangle.svg';

export default {
    name: "popup6_KnowledgeTransfer",
    components: {
        svg_icon
    },
    
    data: function(){
        return {
            label: labels,
        }
    },
    computed: {
        language: function(){
            return this.$store.getters.language;
        },
        triangle: function(){
            return triangle;
        },
    },
}
</script>

<style module>
.widgetContainer {
    /* max-width: 600px; */
    /* border: 1px solid #bebebe; */
    /* background-color: white; */
}

.widgetContainerMain {
    background-color: #0090c1;
    width: 100%;
    height: 100px;
    color: white;
    text-align: center;
    margin-bottom: 3%;
}

.widgetContainerTitle {
    height: 100%;
    display: table;
    margin: 0 auto;
}

.widgetContainerTitleIconWrapper {
    display:table-cell;
    vertical-align: middle;
}

.widgetContainerTitleIcon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1px solid white;
    background-color: white;
    position: relative;
}

.widgetContainer i {
    position: absolute;
    top: 25%;
    transform: translateY(-25%);
    left: 50%;
    transform: translateX(-50%);
}

.widgetContainerTitle p {
    display:table-cell;
    vertical-align: middle;
    font-size: 40px;
    color: white;
    font-weight: 200;
    padding-left: 10px;
}

.triangle{
    position: relative;
    bottom: 30px;
}
.triangle path{
    fill:  #0090c1 !important;
    stroke: none !important;
}

.referenceList {
    background-color: #e5f4f9;
    padding: 20px 0;
    font-style:italic;
    line-height: 1.6;
}

.referenceList li {
    margin-left: 20px;
    margin-bottom: 20px;
    width: 95%;

}

</style>

<style>

</style>